import styled from "styled-components";
import React, {useState} from "react";
import {IconButton} from "@material-ui/core";
import FilterIcon from "@material-ui/icons/FilterList";
import CloseIcon from "@material-ui/icons/Close";

import NumericTextField from "./numeric_text_field";

const Button = styled(IconButton)`
  color: #bbb;
  position: absolute;
  right: 0;
`;

interface ValueFilterProps {
  prefix?: string;
  title: string;
  value: number;
  setValue: (value: null | number) => void;
  step: number;
}

const buttonStyles = {
  padding: "0",
};

export default function ValueFilter({
  prefix,
  title,
  value,
  setValue,
  step,
}: ValueFilterProps) {
  const [showFilter, setShowFilter] = useState(Boolean(value));
  const handleClose = () => {
    setValue(null);
    setShowFilter(false);
  };
  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
        }}
      >
        <span style={{padding: "0 1.5em"}}>{title}</span>
        {showFilter ? (
          <Button onClick={handleClose} style={buttonStyles}>
            <CloseIcon />
          </Button>
        ) : (
          <Button onClick={() => setShowFilter(true)} style={buttonStyles}>
            <FilterIcon />
          </Button>
        )}
      </div>
      {showFilter && (
        <div style={{display: "flex", width: "full"}}>
          <NumericTextField
            prefix={prefix}
            value={value}
            onChange={value => setValue(value)}
            step={step}
            label=""
          />
        </div>
      )}
    </div>
  );
}
